import { render, staticRenderFns } from "./PropertyView.vue?vue&type=template&id=21ccd04c"
import script from "./PropertyView.vue?vue&type=script&lang=js"
export * from "./PropertyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports